// CSS configuration ----------------------

// Import boostrap icons only https://icons.getbootstrap.com/#usage
import "bootstrap-icons/font/bootstrap-icons";

// Project CSS style
import "../../../../app/assets/css/deck-layout.scss";
import "../../../../app/assets/css/deck-core.scss";
import "../css/buttons.scss";

// JS configuration -----------------------

// Import HTMX for remote interactions
import "htmx.org/dist/htmx.js"

// Alpine js for local interactions
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// Custom code shared accross slices
import "../../../../app/assets/js/deck-sample-file.js"
